import { render, staticRenderFns } from "./AnswerView.vue?vue&type=template&id=13c66622&scoped=true&"
import script from "./AnswerView.vue?vue&type=script&lang=js&"
export * from "./AnswerView.vue?vue&type=script&lang=js&"
import style0 from "./AnswerView.vue?vue&type=style&index=0&id=13c66622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c66622",
  null
  
)

export default component.exports